import {
    config,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverLoanLibraryPackingListApi {

    static getLoanLibraryLoanItem(loanLibraryLoanId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/loans/${loanLibraryLoanId}/`,
                requestTypes.GET,
            ),
        );
    }
}

export const loanLibraryPackingListApi = config.environment.MODE === config.modes.SERVER ? serverLoanLibraryPackingListApi : serverLoanLibraryPackingListApi;
